import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_WARBOX_CONVERSATION } from '../constants/actions';
import type { TWarboxConversationActionTypes } from '../types';
import type { IConversation } from 'src/interfaces/conversation';

export const getConversation = async (
    dispatch: Dispatch<TWarboxConversationActionTypes>,
    conversationId: string
): Promise<void> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.get(
            `/conversations/${conversationId}`,
            HEADERS({
                isReadPermissionNecessary: true,
            })
        );

        dispatch({
            type: GET_WARBOX_CONVERSATION,
            payload: res.data.data as IConversation,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
